import React from 'react';
import { AppHeader, Box } from '@ace-clublabs/shared-component-library';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, title = 'Redirecting...' }) => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <AppHeader displayShadow={false} />
      <Box sx={styles.container}>
        <Box sx={styles.card}>
          <h1 style={styles.title}>{title}</h1>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

interface LoadingProps {
  message: string;
}

export const Loading: React.FC<LoadingProps> = ({ message }) => {
  return (
    <div style={styles.status}>
      <div style={styles.spinner}></div>
      <p>{message}</p>
    </div>
  );
};

interface ErrorDisplayProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ message, onRetry }) => {
  return (
    <div style={styles.error}>
      <p>Error: {message}</p>
      {onRetry && (
        <button onClick={onRetry} style={styles.button}>
          Try Again
        </button>
      )}
    </div>
  );
};

const styles: Record<string, React.CSSProperties | object> = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 80px)',
    padding: '1rem',
  },
  card: {
    backgroundColor: 'white',
    padding: '2.5rem 3.5rem',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    textAlign: 'center',
    maxWidth: '500px',
    width: '100%',
  },
  title: {
    margin: '0 0 1.5rem 0',
    color: '#003087',
    fontSize: '1.5rem',
    fontWeight: 600,
  },
  status: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    color: '#666',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '3px solid #e9ecef',
    borderTop: '3px solid #003087',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  error: {
    color: '#dc3545',
  },
  button: {
    marginTop: '1rem',
    padding: '0.75rem 2rem',
    backgroundColor: '#003087',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: 500,
    transition: 'background-color 0.2s ease',
  },
};

// Add spinner animation (only once)
if (typeof document !== 'undefined' && !document.getElementById('spinner-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'spinner-styles';
  styleSheet.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    button:hover {
      background-color: #00256b !important;
    }
  `;
  document.head.appendChild(styleSheet);
}
